import { isEmbedded, getUA } from 'react-device-detect';

// issue: Google's embedded webview Policy
// ref: https://stackoverflow.com/questions/69370491/you-cant-sign-in-from-this-screen-because-this-app-doesnt-comply-with-googles
export const isEmbeddedWebview = () => {
  if (isEmbedded) {
    return true;
  }

  const ua = getUA;
  const regex = '/(WebView|(iPhone|iPod|iPad)(?!.*Safari/)|Android.*(wv|.0.0.0))/gi';
  if (ua.match(regex)) {
    return true;
  }
  if (ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1) {
    return true;
  }

  return false;
};
